export const DECIMAL_SCALE = 9;
